import '@babel/polyfill';
// eslint-disable-next-line sort-imports
import { createHistory, createStore } from '../redux/create';
import config from '../config';
import getInitialData from '../redux/initialData';
import getRoutes from '../routes';
import { isWhiteLabel } from '../redux/modules/whiteLabel';
import renderApp from './renderApp';

let basename = '';
if (window.location.pathname.includes('/en-gb')) {
    basename = '/en-gb';
}

// Create initial state for redux store from server-side render
const initialData = window.__data ? { ...window.__data } : getInitialData({ basename, config });
// Create client-side browser history for React-Router
const history = createHistory({ basename });
// Create Redux store
const store = createStore({ history, initialData });
// Get application routes
const routes = getRoutes(isWhiteLabel(store.getState()));

/**
 * Render the client-side app
 */
if (!global.Intl) {
    Promise.all([
        import(/* webpackChunkName: "ConditionalIntlPolyfill" */ 'intl'),
        import(/* webpackChunkName: "ConditionalIntlPolyfill" */ 'intl/locale-data/jsonp/en.js'),
    ]).then(() => renderApp({ history, routes, store }));
} else {
    renderApp({ history, routes, store });
}
